import { createUploadLink } from 'apollo-upload-client';
import { ApolloClient, from, split, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import sha256 from 'sha256';
import { alert } from 'equasion-lib';
import { LOCAL_API_ORIGIN, LOCAL_API_WS_ORIGIN } from '@/lib/utils/localApiOrigin';

const httpLink = createUploadLink({
  uri: window.location.host.includes('localhost')
    ? `${LOCAL_API_ORIGIN}/api/graphql`
    : '/api/graphql',
  credentials: 'include'
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: window.location.host.includes('localhost')
      ? `${LOCAL_API_WS_ORIGIN}/api/graphql`
      : `wss://${window.location.host}/api/graphql`,
    options: {
      reconnect: true
      // authorization: user.authToken
    },
    connectionParams: () => {
      return {
        test: 'heyo'
      };
    }
  })
);

const errorLink = (logout) =>
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      const {
        message,
        locations,
        extensions: { exception: { stacktrace = [] } = {} } = {}
      } = graphQLErrors[0];
      if (message.includes('Not authorized') || message.includes('Invalid token.')) {
        alert('Error', message.substring(0, 50), 4, 'error');
        logout();
      } else if (message.includes('PersistedQueryNotFound')) {
        // eslint-disable-next-line
        console.log(
          '%cFirst time making request, persisted query failed.',
          'color: green; border-radius: 3px; border: 1px solid green; display: block;'
        );
      } else {
        // eslint-disable-next-line
        console.error(
          `[GraphQL error] \n` +
            `Message: ${message} \n` +
            `Location: ${JSON.stringify(locations)} \n` +
            `Trace: ${stacktrace[0]} ${stacktrace[1]}`
        );
        alert('Error', message.substring(0, 50), 4, 'error');
      }
    }

    // eslint-disable-next-line
    if (networkError) console.error(`[Network error]: ${networkError}`);
  });

const apolloClient = (logout) => {
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    httpLink
  );

  return new ApolloClient({
    link: createPersistedQueryLink({ sha256 }).concat(
      from([errorLink(logout), splitLink])
    ),
    cache: new InMemoryCache()
  });
};

export default apolloClient;
